// this is an autogenerated file from App/Account/Content/Tasks/New/Menu/Expanded/DashboardAction/AssignedToMe/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Tasks_New_Menu_Expanded_DashboardAction_AssignedToMe($user_id: uuid!, $location_id: uuid!) {
  tasks_assignees_aggregate(
    where: {
      user_id: { _eq: $user_id }
      task: {
        stage: {
          done: { _eq: false }
          board: {
            status: { _eq: active }
            metadata: { _contains: { locations: [$location_id] } }
          }
        }
      }
    }
  ) {
    aggregate {
      count
    }
  }
}

`